export default __webpack_public_path__ + "static/media/finanzme.920c31b0.png";